import React from "react";
import { useAdminI18n } from "@/lib/adminI18n";

/**
 * Pill toggle group that lets the admin tag a content item as
 * web-only, mobile-only, or both. Stores the value as an array so the
 * backend Pydantic model can validate it directly.
 *
 * Semantics: both pills enabled → ["web", "mobile"]; toggling one off
 * narrows the audience. Never allows the empty selection (the item
 * would be invisible everywhere) — we always coerce back to "both".
 */
export default function PlatformToggle({ value, onChange, testid }) {
  const { t } = useAdminI18n();
  const list = Array.isArray(value) && value.length ? value : ["web", "mobile"];
  const has = (p) => list.includes(p);

  const toggle = (p) => {
    let next;
    if (has(p)) {
      next = list.filter((x) => x !== p);
    } else {
      next = [...list, p];
    }
    if (next.length === 0) next = ["web", "mobile"];
    onChange(next);
  };

  return (
    <div className="inline-flex items-center gap-1 bg-black/40 border border-white/10 rounded-full p-0.5" data-testid={testid}>
      <PillBtn active={has("web")}    onClick={() => toggle("web")}    label={t("content.website", "Website")} testid={testid ? `${testid}-web` : undefined} />
      <PillBtn active={has("mobile")} onClick={() => toggle("mobile")} label={t("content.app", "App")} testid={testid ? `${testid}-mobile` : undefined} />
    </div>
  );
}

function PillBtn({ active, onClick, label, testid }) {
  return (
    <button
      type="button"
      onClick={onClick}
      data-testid={testid}
      data-active={active ? "true" : "false"}
      className={
        "h-6 px-2.5 rounded-full text-[10px] font-bold uppercase tracking-wider transition-colors " +
        (active ? "bg-[#F37021] text-white" : "text-white/40 hover:text-white/70")
      }
    >
      {label}
    </button>
  );
}
